import { ecClientApi } from "../service";
import ApiRoutes from "../constants/api-routes";

const createProduct = async (data) => {
  try {
    const response = await ecClientApi.post(ApiRoutes.CREATE_PRODUCT, data);
    return response.data;
  } catch (error) {
    console.error("Error creating top deal:", error);
    throw error;
  }
};

const getProducts = async (page, limit) => {
  try {
    const response = await ecClientApi.get(
      ApiRoutes.GET_PRODUCTS + `?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching top deals:", error);
    throw error;
  }
};

const getProductById = async (id) => {
  try {
    const response = await ecClientApi.get(ApiRoutes.GET_PRODUCT_BY_ID + id);
    return response.data;
  } catch (error) {
    console.error(`Error fetching top deal with ID ${id}:`, error);
    throw error;
  }
};

const updateProduct = async (id, data) => {
  try {
    const response = await ecClientApi.put(ApiRoutes.UPDATE_PRODUCT + id, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating top deal with ID ${id}:`, error);
    throw error;
  }
};

const deleteProduct = async (id) => {
  try {
    const response = await ecClientApi.delete(ApiRoutes.DELETE_PRODUCT + id);
    return response.data;
  } catch (error) {
    console.error(`Error deleting top deal with ID ${id}:`, error);
    throw error;
  }
};

export {
  createProduct,
  getProductById,
  getProducts,
  updateProduct,
  deleteProduct,
};
